import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { Cluster } from '../clusters.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class ClustersResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  get(cluster_id: number, params?: QueryParams): Observable<Cluster> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Cluster>(`${this.apiRoot}/${account_id}/api/clusters/${cluster_id}`, { params }),
      ),
    );
  }

  save(body: Partial<Cluster>, params?: QueryParams): Observable<Cluster> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.post<Cluster>(`${this.apiRoot}/${account_id}/api/clusters`, body, { params })),
    );
  }

  update(cluster_id: number, body: Partial<Cluster>, params?: QueryParams): Observable<Cluster> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.put<Cluster>(`${this.apiRoot}/${account_id}/api/clusters/${cluster_id}`, body, { params }),
      ),
    );
  }

  remove(cluster_id: number, params?: QueryParams): Observable<Cluster> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.delete<Cluster>(`${this.apiRoot}/${account_id}/api/clusters/${cluster_id}`, { params }),
      ),
    );
  }

  query(params?: QueryParams): Observable<Cluster[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.get<Cluster[]>(`${this.apiRoot}/${account_id}/api/clusters`, { params })),
    );
  }

  search(params?: QueryParams): Observable<Cluster[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Cluster[]>(`${this.apiRoot}/${account_id}/api/clusters/search`, { params }),
      ),
    );
  }
}

((window as any).xplenty as angular.IModule).service('Cluster', downgradeInjectable(ClustersResource));
